import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B000221FindRequest = Partial<{
  locationCd: string;
  shohinKana: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000221FindResponse = {
  sokoNmr: string;
  locationCd: string;
  shohinNmr: string;
};

export const B000221Find = (props: B000221FindRequest) => {
  return RestClient.get<PageableResponse<B000221FindResponse[]>>(
    "b000221/find",
    {
      params: props,
    }
  );
};

export type B000221GetRequest = { locationCd: string };

export const B000221Get = (props: B000221GetRequest) => {
  return RestClient.get("b000221/get", {
    params: props,
  });
};
